<template>
  <pt-integral-exchange-detail class="pt-integral-exchange-detail__withData" :integralDetail="integralDetail" :operation="operation" @refreshDetail="refreshDetail" @getRefundmentReason="getRefundmentReason" :refundReasonLoading="refundReasonLoading" :refundReasonList="refundReasonList" @getIntegralDetail="getIntegralDetail" :orderStatesArray="orderStatesArray" :IntegralGoods="IntegralGoods"></pt-integral-exchange-detail>
</template>

<script>
import PtIntegralExchangeDetail from './index'
export default {
  name: 'pt-integral-exchange-detail__withData',
  components: {
    'pt-integral-exchange-detail': PtIntegralExchangeDetail
  },
  props: {
    operation: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      integralDetail: {},
      refundReasonLoading: false,
      refundReasonList: [],
      orderStatesArray: [],
      IntegralGoods: {}
    }
  },
  methods: {
    // 获取退还积分原因列表
    getRefundmentReason () {
      let data = {
        type: 'RefundmentReason'
      }
      this.refundReasonLoading = true
      this.$store.dispatch('getIntegralRefundmentReason', data).then(res => {
        this.refundReasonLoading = false
        this.refundReasonList = res
      }).catch(err => {
        this.refundReasonLoading = false
        this.$message(err || '获取退款原因失败')
      })
    },
    refreshDetail () {
      this.getIntegralDetail()
    },
    getIntegralExchangeProgress () {
      this.$store.dispatch('getIntegralExchangeProgress', this.$route.params.id).then(res => {
        this.orderStatesArray = res.data.items
      }).catch(err => {
        this.$message.error(err || '获取失败')
      })
    },
    getIntegralDetail () {
      this.$store.dispatch('getIntegralDetail', this.$route.params.id).then(res => {
        this.integralDetail = res
      }).catch(err => {
        this.$message.error(err || '获取失败')
      })
    }
  },
  created () {
    this.getIntegralExchangeProgress()
    this.getIntegralDetail()
    this.getRefundmentReason()
  }
}
</script>
